<template>
  <div class="activities">
    <div v-if="!isMobileApp" class="divider"></div>
    <div v-if="!isMobileApp" class="activities__menu">
      <Menu />
      <div class="divider"></div>
    </div>

    <div v-if="false" class="activities__categories">
      <span
        v-for="(category, i) in categories"
        :key="i"
        class="categories__item"
        v-html="category"
      ></span>
    </div>
    <div v-if="!loading" class="activities__items">
      <ActivityCard
        v-for="(activity, i) in activities"
        :key="i"
        :title="activity.date"
        :items="activity.items"
      ></ActivityCard>

      <div class="activities__loader" v-if="updating">
        <Loader size="24" />
      </div>
    </div>

    <div class="activities__loader-block"></div>

    <TaskDetailsModal
      :active="taskDetailsModal"
      :state="taskDetailsState"
      :modalOptions="taskDetailsOptions"
      :rating="taskRating"
      @close="onTaskDetailsClose"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Menu from '@/components/Menu/Menu.vue';
import ActivityCard from '@/components/ActivityCard/ActivityCard.vue';
import TaskDetailsModal from '@/components/TaskDetailsModal/TaskDetailsModal.vue';
import ActivityCover3 from '@/assets/img/activity-card/updated.svg';
import ActivityCoverXP from '@/assets/img/activity-card/xp.svg';
import PointIcon from '@/assets/img/point.svg';
import TrainingRun from '@/assets/icons/training-run.svg';
import TrainingWalk from '@/assets/icons/training-walk.svg';
import TrainingCycling from '@/assets/icons/training-cycling.svg';
import TrainingSwim from '@/assets/icons/training-swim.svg';
import TrainingSki from '@/assets/icons/training-ski.svg';
import TrainingDancing from '@/assets/icons/training-dancing.svg';
import TrainingFitness from '@/assets/icons/training-fitness.svg';
import TrainingStrength from '@/assets/icons/training-strength.svg';
import TrainingMartialArts from '@/assets/icons/training-martial-arts.svg';
import TrainingPlaying from '@/assets/icons/training-playing.svg';
import TrainingExtreme from '@/assets/icons/training-extreme.svg';
import TrainingOutdoor from '@/assets/icons/training-outdoor.svg';

export default {
  name: 'Activities',
  components: {
    Menu,
    ActivityCard,
    TaskDetailsModal,
  },
  data() {
    return {
      categories: ['Задания', 'Тренировки', 'Покупки', 'Достижения', 'Другое'],
      activities: [],
      offset: 0,
      taskDetailsModal: false,
      taskDetailsOptions: {},
      taskDetailsState: 'inProgress',
      pageScrollY: 0,
      loading: true,
      updating: false,
      loaderBlock: null,
      taskRating: {},
      operationTypes: '"OperationType"="Achievement" or "OperationType"="ParticipantExercise" or "OperationType"="ParticipantExperienceLevel" or "OperationType"="ParticipantSteps" or "OperationType"="Purchase" or "OperationType"="SportActivity" or "OperationType"="SporadicActivity" or "OperationType"="TeamParticipant"',
    };
  },

  computed: {
    ...mapGetters('settings', ['theme']),
    ...mapGetters('operations', ['searchEventsData']),
    ...mapGetters('exercises', ['task', 'taskPoints', 'taskGuest']),
    ...mapGetters('user', ['isMobileApp', 'profile']),
  },
  methods: {
    ...mapActions('user', ['getProfile']),
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('operations', ['searchEvents']),
    ...mapActions('exercises', ['getTask', 'getTaskPoints', 'getTaskGuest']),
    onHashChange() {
      if (this.$route.name !== 'Activities') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }
      const hash = window.location.hash.split('=');
      if (hash[0] !== '#!showTask') return;
      if (hash.length === 2) {
        this.loadTask(hash[1]);
      }
      if (hash.length === 3 && hash[1].indexOf('&peId') >= 0) {
        this.loadMyTask(hash[1].split('&peId')[0], hash[2]);
      }
    },
    onTaskDetailsClose() {
      this.taskDetailsModal = false;
      window.scroll(0, this.pageScrollY);
      window.location.hash = '';
    },
    loadTask(id) {
      if (!id || id === 'null' || id === 'undefined') {
        window.location.hash = '';
        return;
      }
      this.getTaskGuest(id)
        .then(() => {
          if (this.taskGuest) {
            this.pageScrollY = window.scrollY;
            this.taskDetailsState = 'available';
            this.taskDetailsOptions = this.taskGuest;
            if (id && id !== 'null' && id !== 'undefined') {
              this.getTaskPoints(id)
                .then(() => {
                  this.taskRating = this.taskPoints;
                });
            }
            this.taskDetailsModal = true;
            return;
          }
          window.location.hash = '';
        });
    },
    loadMyTask(id, peId) {
      if (!id || id === 'null' || id === 'undefined') {
        window.location.hash = '';
        return;
      }
      this.getTask(peId)
        .then(() => {
          if (this.task) {
            this.pageScrollY = window.scrollY;
            this.taskDetailsState = this.getTaskDetailsState(this.task);
            this.taskDetailsOptions = this.task;
            if (id && id !== 'null' && id !== 'undefined') {
              this.getTaskPoints(id)
                .then(() => {
                  this.taskRating = this.taskPoints;
                });
            }
            this.taskDetailsModal = true;
            return;
          }
          window.location.hash = `#!showTask=${id}`;
        });
    },
    setupLoader() {
      const vm = this;
      if (vm.loaderBlock !== null) return;
      if (vm.$route.name !== 'Activities') {
        return;
      }
      const loaders = document.getElementsByClassName('activities__loader-block');
      vm.loaderBlock = loaders[0] || null;
      window.addEventListener('scroll', vm.checkForLoading);
      window.addEventListener('touchmove', vm.checkForLoading);
      vm.checkForLoading();
    },
    checkForLoading() {
      if (this.updating) return;
      if (!this.loaderBlock) return;
      if (this.$route.name !== 'Activities') {
        this.cleanup();
        return;
      }

      if (!this.hasItemsForLoading()) return;

      const bottomCoord = this.loaderBlock.getBoundingClientRect().bottom;
      const height = document.documentElement.clientHeight;
      if (height >= bottomCoord) {
        this.updating = true;
        setTimeout(() => { this.updateActivities(); }, 250);
      }
    },
    cleanup() {
      window.removeEventListener('scroll', this.checkForLoading);
      window.removeEventListener('touchmove', this.checkForLoading);
    },
    hasItemsForLoading() {
      if (!this.searchEventsData) return false;
      if (this.searchEventsData.count === 0) return false;
      if (this.getActivitiesCount() >= this.searchEventsData.total) return false;
      return true;
    },
    getActivitiesCount() {
      let count = 0;
      for (let i = 0; i < this.activities.length; i += 1) {
        count += this.activities[i].items.length;
      }
      return count;
    },
    updateActivities() {
      this.offset += 25;
      if (this.profile && this.profile.participantId && this.profile.marketingProgramId) {
        this.searchEvents({
          subjectId: this.profile.participantId,
          tags: [],
          tagsQuery: this.operationTypes,
          offset: this.offset,
          count: 25,
        }).then(() => {
          if (this.searchEventsData && this.searchEventsData.values) {
            const operations = this.searchEventsData.values.map((event) => this.convertEventToOperation(event));
            this.activities.push(...this.getMapppedOperations(operations));
          }
          this.updating = false;
        }).catch(() => {
          this.updating = false;
        });
      } else {
        this.updating = false;
      }
    },
    hasSameTimeAndType(operation1, operation2) {
      if (!operation1 || !operation2) {
        return false;
      }
      const isTraining = (op) => op.operationType === 'SportActivity' || op.operationType === 'SporadicActivity';
      if (!isTraining(operation1) || !isTraining(operation2)) {
        return false;
      }
      const date1 = dayjs(operation1.operationDate);
      const date2 = dayjs(operation2.operationDate);
      if (!date1.isValid() || !date2.isValid()) {
        return false;
      }
      return date1.isSame(date2, 'second');
    },
    getMetadataValue(metadata, name) {
      const item = metadata.find((m) => m.name === name);
      return item ? item.value : null;
    },
    getOperationType(event) {
      const tag = event.tags.find((t) => t.key === 'OperationType');
      return tag ? tag.value : null;
    },
    convertEventToOperation(event) {
      const operationType = this.getOperationType(event);
      const attributes = {};
      event.metadata.forEach((meta) => {
        attributes[meta.name] = meta.value;
      });

      // Добавляем данные из objects (для заданий и других сущностей)
      if (event.objects && event.objects.length > 0) {
        event.objects.forEach((obj) => {
          if (obj.metadata) {
            obj.metadata.forEach((meta) => {
              // Добавляем, только если ещё нет в attributes
              if (!attributes[meta.name]) {
                attributes[meta.name] = meta.value;
              }
            });
          }
        });
      }

      // Получаем ExerciseId из tags или metadata
      let exerciseId = null;
      const exerciseIdTag = event.tags.find((t) => t.key === 'ExerciseId');
      if (exerciseIdTag) {
        exerciseId = exerciseIdTag.value;
      } else {
        // Пробуем найти в metadata
        exerciseId = this.getMetadataValue(event.metadata, 'ExerciseId');
      }

      const activityIdTag = event.tags && event.tags.find((t) => t.key === 'ActivityId');
      const activityId = activityIdTag ? activityIdTag.value : null;

      return {
        operationId: event.eventId || event.operationId || null,
        operationType,
        operationDate: event.operationDate || event.eventDate,
        operationSourceId: this.getMetadataValue(event.metadata, 'OperationSourceId'),
        sourceId: exerciseId,
        attributes,
        state: 'Synchronized',
        activityId,
      };
    },
    filterOperationsByTime(operations) {
      const filteredOperations = [];
      let previousOperation = null;
      for (let i = 0; i < operations.length; i += 1) {
        const currentOperation = operations[i];
        if (previousOperation && this.hasSameTimeAndType(previousOperation, currentOperation)) {
          previousOperation.title += `, ${this.getFormattedDistance(currentOperation)}`;
        } else {
          filteredOperations.push(currentOperation);
          previousOperation = currentOperation;
        }
      }
      return filteredOperations;
    },
    getMapppedOperations(operations) {
      if (!operations) return [];
      const filteredOperations = this.filterOperationsByTime(operations);
      const days = [];
      let currentDay = { date: '', items: [] };
      let sportActivities = [];
      let lastDate = '';
      for (let i = 0; i < filteredOperations.length; i += 1) {
        const value = filteredOperations[i];
        const date = dayjs.utc(value.operationDate).local();
        if (!date.isValid()) continue;
        const formattedDate = date.format('D MMMM');
        const item = this.getMappedItem(value);
        const currentDate = date.format('YYYY-MM-DD');
        if (currentDate !== lastDate) {
          if (lastDate !== '') {
            days.push(currentDay);
          }
          currentDay = { date: formattedDate, items: [] };
          sportActivities = [];
        }
        if (value.operationType === 'SportActivity' || value.operationType === 'SporadicActivity') {
          const existingSportActivity = sportActivities.find((activity) => activity.time === item.time);
          const isSameActivity = existingSportActivity && (
            existingSportActivity.operationId === value.activityId
            || existingSportActivity.activityId === value.operationId
          );
          if (existingSportActivity && isSameActivity) {
            // Та же активность (SportActivity + SporadicActivity): не менять заголовок — оставляем дисциплинарный
          } else if (existingSportActivity) {
            existingSportActivity.activityTexts = existingSportActivity.activityTexts || [];
            existingSportActivity.activityTexts.push(item.activityText);
            const trainingsLink = '/my-settings/trainings';
            const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
            const texts = existingSportActivity.activityTexts;
            const allSame = texts.length > 0 && texts.every((t) => t === texts[0]);
            const formattedList = allSame ? `${texts[0]} (${texts.length})` : new Intl.ListFormat('ru').format(texts);
            existingSportActivity.title = `Получены новые тренировки: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${formattedList}</a>`;
          } else {
            item.activityTexts = [item.activityText];
            // Одна тренировка — только дисциплинарный заголовок из getMappedItem. «Получены новые тренировки» только при нескольких за одно время.
            if (!item.title) {
              const trainingsLink = '/my-settings/trainings';
              const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
              item.title = `Получена тренировка: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${item.activityText}</a>`;
            }
            currentDay.items.push(item);
            sportActivities.push(item);
          }
        } else if (item && item.title) {
          // Добавляем элемент только если у него есть title
          currentDay.items.push(item);
        }
        lastDate = currentDate;
      }
      if (currentDay.items.length > 0) {
        days.push(currentDay);
      }
      return days;
    },
    pluralizeSteps(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return `<b>${count}</b> шаг`;
      } if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        return `<b>${count}</b> шага`;
      }
      return `<b>${count}</b> шагов`;
    },
    getMappedItem(value) {
      const item = {};
      // Нормализация без мутации параметра: если пришёл ответ с metadata/tags без attributes/operationType (сырой API)
      let resolvedAttributes = {};
      if (value && value.attributes && typeof value.attributes === 'object') {
        resolvedAttributes = value.attributes;
      } else if (value && Array.isArray(value.metadata)) {
        const fromMetadata = Object.fromEntries(value.metadata.map((m) => [m.name, m.value]));
        // Иногда API отдаёт одно поле metadata: { name: "Data", value: "{...json...}" }
        if (fromMetadata && typeof fromMetadata.Data === 'string' && fromMetadata.Data.trim().startsWith('{')) {
          try {
            const parsed = JSON.parse(fromMetadata.Data);
            resolvedAttributes = parsed && typeof parsed === 'object' ? parsed : fromMetadata;
          } catch (e) {
            resolvedAttributes = fromMetadata;
          }
        } else {
          resolvedAttributes = fromMetadata;
        }
      }
      const resolvedOperationType = value && (value.operationType != null
        ? value.operationType
        : (value.tags && value.tags.find((t) => t.key === 'OperationType')?.value));
      const val = value ? { ...value, attributes: resolvedAttributes, operationType: resolvedOperationType } : value;

      if (!val) return item;
      if (val.operationType === 'TeamParticipant') {
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.img = val.attributes.TeamLogo || '';
        item.isInternalImg = false;
        if (val.attributes.StateOperation === 'Created') {
          item.title = `Вы присоединились к команде <a href="/my-team?title=Команда">${val.attributes.TeamName}</a>`;
        } else {
          item.title = `Вы покинули команду <span class="team-out">${val.attributes.TeamName}</span>`;
          item.taskStatus = 'rejected';
        }
        return item;
      }
      if (val.operationType === 'Purchase') {
        item.img = val.attributes.ProductMobileImageUrl || '';
        item.isInternalImg = false;
        const rewardLink = `/market/reward?id=${val.attributes.PromotionId || ''}&title=${val.attributes.ProductName}`;
        const mobileRewardLink = `/goPage?name=RewardDetails&path=${encodeURIComponent(rewardLink)}`;
        item.title = `Вы купили <a href="${this.isMobileApp ? mobileRewardLink : rewardLink}">${val.attributes.ProductName}</a>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.coins = -Math.round(val.attributes.Amount);
        return item;
      }
      if (val.operationType === 'ParticipantExercise') {
        item.img = val.attributes.ExerciseMobileImageUrl || '';
        item.isInternalImg = false;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        if (['RejectedManually', 'Rejected'].includes(val.attributes.StateOperation)) {
          item.taskStatus = 'rejected';
          item.title = `Отменено задание <a href="#!showTask=${val.sourceId}">${val.attributes.ExerciseTitle}</a>`;
        } else if (val.attributes.StateOperation === 'Completed') {
          item.taskStatus = 'completed';
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId}&peId=${val.operationSourceId}">${val.attributes.ExerciseTitle}</a>`;
          const rewardNum = parseFloat(val.attributes.Reward);
          if (!Number.isNaN(rewardNum) && rewardNum > 0) {
            item.coins = `+${Math.round(rewardNum)}`;
          }
        } else {
          // Для Created и других статусов - без иконки
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId}&peId=${val.operationSourceId}">${val.attributes.ExerciseTitle}</a>`;
        }
        return item;
      }
      // SportActivity и SporadicActivity — одна и та же логика отображения (иконка по дисциплине, заголовок, награды)
      if (val.operationType === 'SportActivity' || val.operationType === 'SporadicActivity') {
        const discipline = val.attributes.Discipline || '';

        item.operationId = val.operationId;
        item.activityId = val.activityId || null;
        item.img = this.getTrainingIcon(discipline);
        item.isInternalImg = true;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        const trainingsLink = '/my-settings/trainings';
        const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
        const finalTrainingsLink = this.isMobileApp ? mobileTrainingsLink : trainingsLink;
        const activityTitle = this.getFormattedSportActivityTitle(val, finalTrainingsLink);

        const activityText = val.attributes.Distance ? this.getFormattedDistance(val) : this.formatValue(val);
        item.activityText = activityText;
        item.title = activityTitle;

        const coinsValue = val.attributes.Reward
          || val.attributes.AccruedPoints
          || val.attributes.Coins
          || val.attributes.Amount
          || val.attributes.Points;
        if (coinsValue && parseFloat(coinsValue) > 0) {
          item.coins = `+${Math.round(parseFloat(coinsValue))}`;
        }

        const pointsValue = val.attributes.RatingPoints
          || val.attributes.Experience
          || val.attributes.XP
          || val.attributes.ExperiencePoints;
        if (pointsValue && parseFloat(pointsValue) > 0) {
          item.points = `+${Math.round(parseFloat(pointsValue))}`;
        }

        return item;
      }
      if (val.operationType === 'Achievement') {
        item.img = (val.attributes && val.attributes.ActiveIcon) ? val.attributes.ActiveIcon : '';
        item.isInternalImg = true;
        item.achievementType = val.attributes ? val.attributes.AchievementType : '';
        item.title = `Вы разблокировали достижение <b>${val.attributes && val.attributes.Title ? val.attributes.Title : ''}</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantExperienceLevel') {
        item.img = ActivityCoverXP;
        item.isInternalImg = true;
        item.title = `Вы достигли <b>${val.attributes.Level} ур.</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantExperience') {
        item.img = PointIcon;
        item.isInternalImg = true;
        const xpValue = val.attributes.Value ? Math.round(parseFloat(val.attributes.Value)) : 0;
        if (val.attributes.ExerciseTitle && val.sourceId) {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга за выполнение задания <a href="#!showTask=${val.sourceId}">${val.attributes.ExerciseTitle}</a>`;
        } else if (val.attributes.ExerciseTitle) {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга за выполнение задания <b>${val.attributes.ExerciseTitle}</b>`;
        } else {
          item.title = `Начислено <b>${xpValue}</b> очков рейтинга`;
        }
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantSteps') {
        item.isInternalImg = false;
        item.img = '';
        item.isTaskSteps = true;
        item.StepsCount = Math.round(val.attributes.StepsCount);
        item.title = `Вы прошли ${this.pluralizeSteps(item.StepsCount)}`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        const accruedNum = parseFloat(val.attributes.AccruedPoints);
        if (!Number.isNaN(accruedNum) && accruedNum > 0) {
          item.coins = `+${Math.round(accruedNum)}`;
        }
        return item;
      }
      item.img = '';
      item.isInternalImg = false;
      item.achievementType = '';
      item.title = '';
      item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
      return item;
    },
    formatValue(value) {
      const { attributes } = value;
      let discipline = attributes.Discipline || '';
      if (discipline === 'Dancing') {
        discipline = 'Танцы';
      } if (discipline === 'Fitness') {
        discipline = 'Гибкость и контроль';
      } if (discipline === 'Strength') {
        discipline = 'Силовые тренировки';
      } if (discipline === 'MartialArts') {
        discipline = 'Боевые искусства';
      } if (discipline === 'Playing') {
        discipline = 'Игровые виды спорта';
      } if (discipline === 'Extreme') {
        discipline = 'Экстремальные и outdoor-активности';
      } if (discipline === 'Outdoor') {
        discipline = 'Свободная тренировка';
      }

      if (!discipline) discipline = 'Тренировка';

      const rawTime = attributes.TimeInSeconds;
      const parsedTime = rawTime !== undefined && rawTime !== null && rawTime !== ''
        ? parseInt(rawTime, 10)
        : NaN;
      const hasTime = Number.isFinite(parsedTime) && parsedTime > 0;

      const rawCalories = attributes.Calories ?? attributes.calories;
      const parsedCalories = rawCalories !== undefined && rawCalories !== null && rawCalories !== ''
        ? Number(rawCalories)
        : NaN;
      const hasCalories = Number.isFinite(parsedCalories) && parsedCalories > 0;

      const rawPulse = attributes.Pulse;
      const parsedPulse = rawPulse !== undefined && rawPulse !== null && rawPulse !== ''
        ? Number(rawPulse)
        : NaN;
      const hasPulse = Number.isFinite(parsedPulse) && parsedPulse > 0;

      let timeFormatted = '';
      if (hasTime) {
        const hours = Math.floor(parsedTime / 3600);
        const minutes = Math.floor((parsedTime % 3600) / 60);
        const seconds = parsedTime % 60;
        timeFormatted = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      const caloriesText = hasCalories ? `${Number.isInteger(parsedCalories) ? parsedCalories : parsedCalories.toFixed(0)} ккал` : '';
      const pulseText = !hasCalories && hasPulse ? `${Number.isInteger(parsedPulse) ? parsedPulse : parsedPulse.toFixed(0)} уд/мин` : '';
      return [discipline, timeFormatted, caloriesText || pulseText].filter(Boolean).join(' • ');
    },
    getTrainingIcon(discipline) {
      if (discipline === 'Running') return TrainingRun;
      if (discipline === 'Walking') return TrainingWalk;
      if (discipline === 'Cycling') return TrainingCycling;
      if (discipline === 'Swimming') return TrainingSwim;
      if (discipline === 'Skiing') return TrainingSki;
      if (discipline === 'Dancing') return TrainingDancing;
      if (discipline === 'Fitness') return TrainingFitness;
      if (discipline === 'Strength') return TrainingStrength;
      if (discipline === 'MartialArts') return TrainingMartialArts;
      if (discipline === 'Playing') return TrainingPlaying;
      if (discipline === 'Extreme') return TrainingExtreme;
      if (discipline === 'Outdoor') return TrainingOutdoor;
      return ActivityCover3; // fallback
    },
    getFormattedSportActivityTitle(value, trainingsLink = '/my-settings/trainings') {
      if (!value || !value.attributes) return '';
      const { attributes } = value;
      const discipline = attributes.Discipline || '';
      const distance = attributes.Distance ? parseInt(attributes.Distance, 10) : null;
      const timeInSeconds = attributes.TimeInSeconds ? parseInt(attributes.TimeInSeconds, 10) : 0;
      const calories = attributes.Calories ?? attributes.calories;
      const hasCalories = calories !== undefined && calories !== null && Number(calories) > 0;

      const rawPulse = attributes.Pulse;
      const parsedPulse = rawPulse !== undefined && rawPulse !== null && rawPulse !== ''
        ? Number(rawPulse)
        : NaN;
      const hasPulse = Number.isFinite(parsedPulse) && parsedPulse > 0;

      // Форматирование расстояния
      let distanceText = '';
      if (distance !== null && distance > 0) {
        const unit = distance >= 1000 ? 'км' : 'м';
        let formatted = '';
        if (distance >= 1000) {
          formatted = (distance / 1000).toFixed(2);
          if (formatted[formatted.length - 1] === '0') formatted = formatted.slice(0, formatted.length - 1);
          if (formatted.indexOf('.0') >= 0) formatted = formatted.slice(0, formatted.indexOf('.0'));
          formatted = formatted.replace('.', ',');
        } else {
          formatted = distance.toString();
        }
        distanceText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${formatted} ${unit}</a>`;
      }

      // Форматирование времени
      let durationText = '';
      if (timeInSeconds > 0) {
        const minutes = Math.floor(timeInSeconds / 60);
        durationText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${minutes} мин</a>`;
      }

      // Калории или пульс: при наличии калорий показываем их, иначе — пульс
      const caloriesText = hasCalories
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number(calories)} ккал</a>`
        : '';
      const pulseText = !hasCalories && hasPulse
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number.isInteger(parsedPulse) ? parsedPulse : parsedPulse.toFixed(0)} уд/мин</a>`
        : '';
      const caloriesOrPulseText = caloriesText || pulseText;

      // Формирование текста в зависимости от дисциплины
      let prefix = '';
      if (discipline === 'Running') {
        prefix = 'Получена тренировка по бегу:';
      } else if (discipline === 'Walking') {
        prefix = 'Получена тренировка по ходьбе:';
      } else if (discipline === 'Cycling') {
        prefix = 'Получена велотренировка:';
      } else if (discipline === 'Swimming') {
        prefix = 'Получена тренировка по плаванию:';
      } else if (discipline === 'Skiing') {
        prefix = 'Получена тренировка по лыжам:';
      } else if (discipline === 'Dancing') {
        prefix = 'Получена тренировка по танцам:';
      } else if (discipline === 'Fitness') {
        prefix = 'Получена тренировка на гибкость и контроль:';
      } else if (discipline === 'Strength') {
        prefix = 'Получена силовая тренировка:';
      } else if (discipline === 'MartialArts') {
        prefix = 'Получена тренировка по боевым искусствам:';
      } else if (discipline === 'Playing') {
        prefix = 'Получена тренировка по игровым видам спорта:';
      } else if (discipline === 'Extreme') {
        prefix = 'Получена тренировка по экстремальным видам спорта:';
      } else if (discipline === 'Outdoor') {
        prefix = 'Получена свободная тренировка:';
      }
      if (['Dancing', 'Fitness', 'Strength', 'MartialArts', 'Playing', 'Extreme', 'Outdoor'].includes(discipline)) {
        const parts = [durationText, caloriesOrPulseText].filter(Boolean);
        return parts.length ? `${prefix} ${parts.join(', ')}` : prefix;
      }
      if (!prefix) {
        prefix = 'Получена тренировка:';
      }

      // Для циклических видов спорта показываем расстояние, время и калории/пульс при наличии
      const cyclicParts = [distanceText, durationText, caloriesOrPulseText].filter(Boolean);
      if (cyclicParts.length) {
        return `${prefix} ${cyclicParts.join(', ')}`;
      }

      return prefix;
    },
    getFormattedDistance(value) {
      if (!value || !value.attributes) return '';
      const distance = parseInt(value.attributes.Distance, 10);
      const unit = distance >= 1000 ? 'км' : 'м';
      let formatted = '';
      if (distance >= 1000) {
        formatted = (distance / 1000).toFixed(2);
        if (formatted[formatted.length - 1] === '0') formatted = formatted.slice(0, formatted.length - 1);
        if (formatted.indexOf('.0') >= 0) formatted = formatted.slice(0, formatted.indexOf('.0'));
        formatted = formatted.replace('.', ',');
      } else {
        formatted = distance.toString();
      }
      if (value.attributes.Discipline === 'Walking') return `${formatted} ${unit} ходьба`;
      if (value.attributes.Discipline === 'Running') return `${formatted} ${unit} бег`;
      if (value.attributes.Discipline === 'Cycling') return `${formatted} ${unit} велозаезд`;
      if (value.attributes.Discipline === 'Swimming') return `${formatted} ${unit} плавание`;
      if (value.attributes.Discipline === 'Skiing') return `${formatted} ${unit} лыжи`;
      return '';
    },
    getFormattedTaskState(value) {
      if (!value || !value.attributes) return '';
      if (value.attributes.StateOperation === 'Created') return 'Вы начали задание';
      if (value.attributes.StateOperation === 'Completed') return 'Вы успешно выполнили задание';
      return '';
    },
    getTaskDetailsState(task) {
      if (task.participantExercise.state === 'Created') return 'inProgress';
      if (task.participantExercise.state === 'Completed') return 'completed';
      if (task.participantExercise.state === 'Rejected') return 'failed';
      if (task.participantExercise.state === 'AwaitingConfirmation') return 'checking';
      return '';
    },
  },
  mounted() {
    this.getProfile();
    this.getBalance();
    const vm = this;

    // Используем новый API searchEvents
    this.getProfile().then(() => {
      if (this.profile && this.profile.participantId && this.profile.marketingProgramId) {
        this.searchEvents({
          subjectId: this.profile.participantId,
          tags: [],
          tagsQuery: this.operationTypes,
          offset: 0,
          count: 25,
        }).then(() => {
          if (this.searchEventsData && this.searchEventsData.values) {
            // Конвертируем события в операции
            const operations = this.searchEventsData.values.map((event) => this.convertEventToOperation(event));
            this.activities = this.getMapppedOperations(operations);
            this.loading = false;
            setTimeout(() => { vm.setupLoader(); }, 250);
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });

    window.addEventListener('hashchange', this.onHashChange);
    this.onHashChange();
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Activities";
</style>
